import appSchema from '../../schema/appSchema.js';
import { getArgumentValue } from '../getArgumentValue.js';

const isDefaultOperator = (operator) => {
  return appSchema?.api?.filters?.operators?.some((n) => n.value.toLowerCase() === operator.toLowerCase());
};

export const validateAdvancedFilters = async ({ conditions, name = 'condition', status }) => {
  if (!conditions?.filterSet || !Array.isArray(conditions.filterSet)) {
    return { status, message: `${status === 'invalid' ? 'Fix' : 'Set'} ${name} filters` };
  }

  const validateSingleFilter = async (filter, filterName) => {
    if (filter.type === 'nested') {
      if (!filter.filterSet || !Array.isArray(filter.filterSet) || filter.filterSet.length === 0) {
        return { status, message: `${status === 'invalid' ? 'Fix' : 'Add'} filters to ${filterName} group` };
      }

      // Recursively validate nested filters
      for (const nestedFilter of filter.filterSet) {
        const result = validateSingleFilter(nestedFilter, filterName);
        if (result.status !== 'valid') {
          return result;
        }
      }

      return { status: 'valid' };
    }

    // Regular filter validation
    const field = await getArgumentValue({ arg: filter?.field, opts: { format: 'human' } });
    const operator = filter?.operator;
    const value = Array.isArray(filter?.value) ? await Promise.all(filter?.value?.map((v) => getArgumentValue({ arg: v, opts: { format: 'human' } }))) : await getArgumentValue({ arg: filter?.value, opts: { format: 'human' } });

    if (!field) {
      return { status, message: `${status === 'invalid' ? 'Fix' : 'Set'} ${filterName} field` };
    }

    if (!operator) {
      return { status, message: `${status === 'invalid' ? 'Fix' : 'Set'} ${filterName} operator` };
    }

    const isDefault = isDefaultOperator(operator);
    if (!isDefault) {
      return { status: 'valid' };
    }

    if (!['exist', 'nexist', 'empty', 'nempty'].includes(operator)) {
      // Check if value is truly empty (null/undefined/empty string), but allow false and 0
      const isValueEmpty = value === null || value === undefined || value === '' || (Array.isArray(value) && (value.length === 0 || value.every((v) => v === null || v === undefined || v === '')));
      if (isValueEmpty) {
        return { status, message: `${status === 'invalid' ? 'Fix' : 'Set'} ${filterName} value` };
      }
    }

    return { status: 'valid' };
  };

  // Validate each filter in the root filterSet
  for (const filter of conditions.filterSet) {
    const result = await validateSingleFilter(filter, name);
    if (result.status !== 'valid') {
      return result;
    }
  }

  return { status: 'valid' };
};
